<app-header [navbarBrandRouterLink]="['/']" [fixed]="true"
    [navbarBrandFull]="{src: 'assets/images/logo/petiak.png', width: 89, height: 37, alt: 'Petiak'}"
    [navbarBrandMinimized]="{src: 'assets/images/logo/petiak-small.png', width: 30, height: 30, alt: 'Petiak'}"
    [asideMenuToggler]="false" [mobileAsideMenuToggler]="false" [sidebarToggler]="false" [mobileSidebarToggler]="false">
    <span class="float-left pr-2">{{'TDLTE_ONLINE_SALE' | translate}}</span>
</app-header>


<div id="page" class="p-4">
    <form (submit)="onFormSubmit()" id="seedForm" [hidden]="this.provider || tried">
        <!-- <img class="d-block mx-auto" src="./assets/images/logo/petiak.png" alt="Petiak" (click)="home()"> -->
        <div class="dx-fieldset">
            <div class="dx-fieldset-header">{{'TDLTE_ONLINE_SALE' | translate}}</div>
            <div class="dx-field" *ngIf="!legalAccount && !naturalAccount">
                <div class="dx-field-label">{{'PERSON_TYPE' | translate}}</div>
                <div class="dx-field-value">
                    <dx-radio-group dir="ltr" [items]="['حقوقی', 'حقیقی']" layout="horizontal"
                        [(ngModel)]="seed.person_type" name="person_type">
                    </dx-radio-group>
                </div>
            </div>
        </div>
        <div #recaptcha></div>
        <div class="dx-fieldset" style="text-align: center;">
            <dx-validation-summary id="summary"></dx-validation-summary>

            <dx-button *ngIf="captchaVerified" id="button" text="{{'CONFIRM' | translate}}" type="success"
                [useSubmitBehavior]="true">
            </dx-button>
        </div>
    </form>

    <ngb-alert type="danger" [dismissible]="false" *ngIf="errorMsg">
        {{errorMsg | translate}}
        <button type="button" class="btn btn-warning float-left"
            *ngIf="current_state !== 'INQUIRY' && current_state !== 'CHOOSE_SERVICE'" (click)="return()">{{
            'RETURN_TO_BACK' | translate}}</button>
    </ngb-alert>

    <ngb-alert type="success" [dismissible]="false" *ngIf="successMsg">
        {{successMsg | translate}}
        <button type="button" class="btn btn-warning float-left"
            *ngIf="current_state === 'CHOOSE_SERVICE' && !legalAccount && !naturalAccount"
            (click)="togglePersonType()">{{ (seed.person_type == 'حقیقی' ? 'CHANGE_TO_LEGAL' : 'CHANGE_TO_NATURAL') |
            translate}}</button>
        <button type="button" class="btn btn-warning float-left"
            *ngIf="current_state !== 'INQUIRY' && current_state !== 'CHOOSE_SERVICE'" (click)="return()">{{
            'RETURN_TO_BACK' | translate}}</button>
    </ngb-alert>

    <form (submit)="onLeadFormSubmit()" id="leadForm"
        [hidden]="!errorMsg || (errorMsg && !errorMsg.includes('TDLTE_INQUIRY_NOK_')) || seed.code != '021' || leaded">
        <div class="dx-fieldset">
            <div class="dx-field">
                <div class="dx-field-label">{{'NAME' | translate}}</div>
                <div class="dx-field-value">
                    <dx-text-box [(ngModel)]="lead.name" name="name">
                        <!-- <dx-validator>
                            <dxi-validation-rule type="required" message="نام اجباری می‌باشد">
                            </dxi-validation-rule>
                        </dx-validator> -->
                    </dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">{{'FAMILY' | translate}}</div>
                <div class="dx-field-value">
                    <dx-text-box [(ngModel)]="lead.family" name="family">
                        <!-- <dx-validator>
                            <dxi-validation-rule type="required" message="نام خانوادگی اجباری می‌باشد">
                            </dxi-validation-rule>
                        </dx-validator> -->
                    </dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">{{'TEL' | translate}}</div>
                <div class="dx-field-value">
                    <dx-text-box [(ngModel)]="lead.tel" name="tel">
                        <dxi-validation-rule type="pattern" pattern="\d{11}" message="فقط عدد">
                        </dxi-validation-rule>
                        <!-- <dx-validator>
                            <dxi-validation-rule type="required" message="تلفن اجباری می‌باشد">
                            </dxi-validation-rule>
                        </dx-validator> -->
                    </dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">{{'MOBILE' | translate}}</div>
                <div class="dx-field-value">
                    <dx-text-box [(ngModel)]="lead.mobile" name="mobile">
                        <dxi-validation-rule type="pattern" pattern="\d{11}" message="فقط عدد">
                        </dxi-validation-rule>

                        <!-- <dx-validator>
                            <dxi-validation-rule type="required" message="تلفن همراه اجباری می‌باشد">
                            </dxi-validation-rule>
                        </dx-validator> -->
                    </dx-text-box>
                </div>
            </div>
            <div class="dx-field">
                <div class="dx-field-label">{{'ADDRESS' | translate}}</div>
                <div class="dx-field-value">
                    <dx-text-area [(ngModel)]="lead.address" name="address">
                        <!-- <dx-validator>
                            <dxi-validation-rule type="required" message="نشانی اجباری می‌باشد">
                            </dxi-validation-rule>
                        </dx-validator> -->
                    </dx-text-area>
                </div>
            </div>
        </div>
        <div class="dx-fieldset" style="text-align: center;">
            <dx-button id="button" text="{{'CONFIRM' | translate}}" type="success" [useSubmitBehavior]="true">
            </dx-button>
        </div>
    </form>

    <app-service-chooser *ngIf="provider && tried && !servicePrice" service_type="TDLTE" [vendor]="provider"
        [person_type]="seed.person_type == 'حقیقی' ? 'N' : 'L'" (choosed)="serviceChoosed($event)">
    </app-service-chooser>

    <app-item-chooser *ngIf="provider && tried && servicePrice && !itemPrice" service_type="TDLTE" [vendor]="provider"
        [person_type]="seed.person_type == 'حقیقی' ? 'N' : 'L'" (choosed)="itemChoosed($event)"></app-item-chooser>

    <app-account-natural-form hiddenReset="true" hiddenCancel="true" hiddenClose="true" title="CREATE_NATURAL_PERSON"
        (done)="naturalAccountSaved($event)"
        *ngIf="provider && tried && servicePrice && itemPrice && seed.person_type == 'حقیقی' && !naturalAccount">
    </app-account-natural-form>

    <app-account-natural-form hiddenReset="true" hiddenCancel="true" hiddenClose="true" title="CREATE_LEGAL_AGENT"
        (done)="legalAgentAccountSaved($event)"
        *ngIf="provider && tried && servicePrice && itemPrice && seed.person_type == 'حقوقی' && !legalAgentAccount">
    </app-account-natural-form>
    <app-account-legal-form hiddenReset="true" hiddenCancel="true" hiddenClose="true"
        [agentId]="legalAgentAccount.email" title="CREATE_LEGAL_PERSON" (done)="legalAccountSaved($event)"
        *ngIf="provider && tried && servicePrice && itemPrice && seed.person_type == 'حقوقی' && legalAgentAccount && !legalAccount">
    </app-account-legal-form>
    <!-- <div *ngIf="legalAccount || naturalAccount"> -->
    <div *ngIf="provider && servicePrice && itemPrice && (legalAccount || naturalAccount)">
        <h2 style="text-align: center; margin-bottom: 10px;">{{'STATEMENT' | translate}} {{seed.code}}{{seed.no}}</h2>

        <table id="invoice" class="table table-striped table-bordered">
            <thead>
                <tr>
                    <th>{{'DESCRIPTION' | translate}}</th>
                    <th>{{'AMOUNT' | translate}}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngIf="servicePrice && servicePrice.price">
                    <td>{{'SERVICE' | translate}} {{servicePrice.service_name}} {{servicePrice['length_'+ lang]}}</td>
                    <td>{{servicePrice.price | money}}</td>
                </tr>
                <tr *ngIf="activation_fee">
                    <td>{{'ACTIVATION_FEE' | translate}}</td>
                    <td>{{activation_fee | money}}</td>
                </tr>
                <tr *ngIf="wire_cost">
                    <td>{{'WIRE_COST' | translate}}</td>
                    <td>{{wire_cost | money}}</td>
                </tr>
                <tr *ngIf="installation_cost">
                    <td>{{'INSTALLATION_COST' | translate}}</td>
                    <td>{{installation_cost | money}}</td>
                </tr>
                <tr *ngIf="transportation_cost">
                    <td>{{'INSTALLATION_TRANSPORTATION_COST' | translate}}</td>
                    <td>{{transportation_cost | money}}</td>
                </tr>
                <tr *ngIf="itemPrice && itemPrice.price">
                    <td>{{'MODEM' | translate}} {{itemPrice.item_name}}</td>
                    <td>{{itemPrice.price | money}}</td>
                </tr>
                <tr *ngIf="shipmentCost">
                    <td>{{'SHIPPING_COST' | translate}}</td>
                    <td>{{shipmentCost| money}}</td>
                </tr>
                <tr>
                    <td class="table-primary">{{'TOTAL' | translate}}</td>
                    <td class="table-primary">{{total | money}}</td>
                </tr>
                <tr>
                    <td class="table-warning">{{'VAT' | translate}}</td>
                    <td class="table-warning">{{vat | money}}</td>
                </tr>
                <tr>
                    <td class="table-success">{{'PAYABLE' | translate}}</td>
                    <td class="table-success">{{payable | money}}</td>
                </tr>
                <tr>
                    <td>
                        {{'REQUEST_INSTALL' | translate}}
                    </td>
                    <td>
                        <dx-check-box [(ngModel)]="requestInstall">
                        </dx-check-box>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <h4>{{'INSTALL_LOCATION' | translate}}</h4>
                        <div class="dx-fieldset" style="margin: 0;">
                            <div class="dx-field-label">{{'PROVINCE' | translate}}</div>
                            <div class="dx-field-value">
                                <dx-text-box [(ngModel)]="installLocation.province" readOnly="true">
                                </dx-text-box>
                            </div>
                            <div class="dx-field-label">{{'CITY' | translate}}</div>
                            <div class="dx-field-value">
                                <dx-text-box [(ngModel)]="installLocation.city" readOnly="true">
                                </dx-text-box>
                            </div>
                            <div class="dx-field-label">{{'ADDRESS' | translate}}</div>
                            <div class="dx-field-value">
                                <dx-text-area [(ngModel)]="installLocation.address"></dx-text-area>
                            </div>
                            <div class="dx-field-label">{{'UNIT' | translate}}</div>
                            <div class="dx-field-value">
                                <dx-text-box [(ngModel)]="installLocation.unit" mode="number"></dx-text-box>
                            </div>
                            <div class="dx-field-label">{{'POSTAL_CODE' | translate}}</div>
                            <div class="dx-field-value">
                                <dx-text-box [(ngModel)]="installLocation.postal_code"></dx-text-box>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <a href="https://my.petiak.com/api/docs/xdsl_terms.pdf" target="_blank" download>
                            {{'TERMS'|translate}}
                        </a>
                    </td>
                </tr>
                <tr>
                    <td>
                        {{'ACCEPT_TERMS' | translate}}
                    </td>
                    <td>
                        <dx-check-box [(ngModel)]="termsChecked"></dx-check-box>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style="text-align: center;">
                        <dx-button
                            [disabled]="!termsChecked || !installLocation.address || !installLocation.postal_code"
                            text="{{'ONLINE_PAYMENT' | translate}}" type="success" (click)="pay()">
                        </dx-button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>